import mockAxios, { AxiosResponse } from 'axios';
import { ITariffServiceMock } from './tariff.mock.types';

export const mockTariffService = (): ITariffServiceMock => ({
  fetchTariffRates: jest.fn(),
  fetchTariffRate: jest.fn(),
  createTariffRate: jest.fn(),
  updateTariffRate: jest.fn(),
  deleteTariffRate: jest.fn(),

  fetchTariffRegions: jest.fn(),
  fetchTariffRegion: jest.fn(),
  createTariffRegion: jest.fn(),
  updateTariffRegion: jest.fn(),
  deleteTariffRegion: jest.fn(),

  fetchTariffExceptions: jest.fn(),
  fetchTariffException: jest.fn(),
  createTariffException: jest.fn(),
  updateTariffException: jest.fn(),
  deleteTariffException: jest.fn(),
  uploadTariffExceptions: jest.fn()
});

export function mockTariffAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
